/* eslint-disable */

import React, { Component } from 'react';
import { isTrue } from '../../helpers/isTrue';
import { getUpgradeUrl, shouldPromoteFreeAiTracking } from '../../helpers/upgradeUrl';
import SearchDropdown from '../../modules/SearchDropdown';
import ActivatePlanComponent from '../../modules/ActivatePlanComponent';
import StripeMessage from '../StripeMessage';
import Sidebar from './Sidebar';
import TopMenu from './TopMenu';
import NotificationsBell from './Notifications';
import { getMeApi, getSubscriptionsApi, logout, setView } from './query';
import {
    BadgeDollarSign,
    FileText,
    Landmark,
    UserSearch,
    UsersRound,
    Wallet,
    WalletCards,
} from 'lucide-react';
import { changeLanguage } from '../../translation/functions';
import Language from './language';
import { withTranslation } from 'react-i18next';
import ShowMessage from '../ShowMessage';
import { getOnboardingInfoQuery } from '../../modules/Onboarding/query';
import { showMessage } from '../../helpers/showMessage';

class Layout extends Component {
    constructor(props) {
        super();
        this.classTypes = ['menu-version', 'mini-menu'];

        this.body = document.getElementsByTagName('body')[0];
        this.changeMoodEvent = new Event('changeMoodEvent');
        this.getUserStatus = new Event('getUserStatus');
        this.changeDomainVisibilityEvent = new Event('changeDomainVisibilityEvent');

        this.toggleMode = this.toggleMode.bind(this);
        this.updateStyle = this.updateStyle.bind(this);
        this.toggleResponsiveTopMenu = this.toggleResponsiveTopMenu.bind(this);
        this.toggleDomainVisibility = this.toggleDomainVisibility.bind(this);
        this.handleMoodeChange = this.handleMoodeChange.bind(this);
        this.getPermissions = this.getPermissions.bind(this);
        this.getOnboardingData = this.getOnboardingData.bind(this);
        this.getSubscription = this.getSubscription.bind(this);
        this.getMe = this.getMe.bind(this);

        const defaultMode = localStorage.getItem('dark-mode');

        const isHiddenDomain = localStorage.getItem('hide-domain');
        let modeIconClassName = 'icon-moon';
        let control_domain_btn_name = 'Hide domain';

        if (isHiddenDomain === 'true') {
            control_domain_btn_name = 'Show Domain';
            this.body.classList.add('hide-domain');
        }

        if (defaultMode === 'true') {
            modeIconClassName = 'icon-sun';
            this.body.classList.add('dark-mode');
        }

        const isDark = JSON.parse(localStorage.getItem('dark-mode'));

        const existingUsersData = localStorage.getItem('subscriptions')
            ? JSON.parse(localStorage.getItem('subscriptions'))
            : {};

        this.state = {
            has_commerce: isTrue(props.has_commerce),
            is_superuser: isTrue(props.is_superuser),
            dont_show_domain: isTrue(props.dont_show_domain),
            need_onboard:
                isTrue(props.need_onboard) && window.location.pathname !== '/customers/onboarding/',
            control_domain_btn_name: control_domain_btn_name,
            modeIconClassName,
            show_activate_plan_btn: false,
            show_demo_button: false,
            isNotViewer: !!window.is_not_viewer,
            openResponsiveTopMenu: false,
            isDark: !!isDark,
            show_reactivate_button: false,
            show_discover_analytics: false,
            show_gsc_data: false,
            show_ai_tracking: false,
            show_commerce: false,
            onboardingInfo: null,
            showTopBanner: false,
            user_subscription_info: existingUsersData[window.info.user] ?? {},
            user_permissions: {},
            // Server-rendered value is only the initial fallback; it is replaced by /api/v1/me/.
            default_domain_id: props.default_domain_id,
        };
    }

    async componentDidMount() {
        document.addEventListener('changeMoodEvent', this.handleMoodeChange);
        document.addEventListener('getPermissionsEvent', this.getPermissions);
        this.getPermissions();
        this.getOnboardingData();
        this.getSubscription();
        this.getMe();
    }

    componentWillUnmount() {
        document.removeEventListener('changeMoodEvent', this.handleMoodeChange);
        document.removeEventListener('getPermissionsEvent', this.getPermissions);
    }

    componentDidUpdate() {
        // The free AI Tracking offer is shown to every user who is not already entitled to AI
        // Tracking, not just legacy (old-billing) users.
        if (shouldPromoteFreeAiTracking(this.state.user_permissions) && !this.state.showTopBanner) {
            this.setState({
                showTopBanner: true,
            });
            const content = document.getElementById('content-id');
            content.style.paddingTop = '160px';
        }
    }

    async getMe() {
        try {
            const res = await getMeApi();
            if (!res.ok) return;
            const data = await res.json();
            this.setState({
                default_domain_id: data?.default_domain?.id ?? null,
            });
        } catch (err) {
            console.log(err);
        }
    }

    async getOnboardingData() {
        try {
            if (window.location.pathname === '/customers/onboarding/') return;
            const res = await getOnboardingInfoQuery();
            const data = await res.json();
            this.setState({
                need_onboard: data?.need_onboard,
            });
        } catch (err) {
            showMessage(err?.message ?? this.props.t('global.something_went_wrong'), 'error');
        }
    }

    async getSubscription() {
        try {
            const info = window.info;
            const existingUsersData = localStorage.getItem('subscriptions')
                ? JSON.parse(localStorage.getItem('subscriptions'))
                : {};

            if (existingUsersData[info.user])
                window.user_subscription_info = existingUsersData[info.user];

            const res = await getSubscriptionsApi();
            const data = await res.json();

            existingUsersData[info.user] = data;
            localStorage.setItem('subscriptions', JSON.stringify(existingUsersData));
            window.user_subscription_info = data;

            this.setState({
                user_subscription_info: data,
            });
            const getSubscriptionEvent = new Event('getSubscriptionEvent');
            document.dispatchEvent(getSubscriptionEvent);
        } catch (err) {
            console.log(err);
        }
    }

    async getPermissions() {
        try {
            const data = window.user_permissions || {};
            const user_status = window.user_permissions?.subscription_status || {};
            const user_is_active = window.user_permissions?.is_active || false;

            if (user_status === 'trialing') {
                this.setState({
                    show_activate_plan_btn: true,
                    show_demo_button: false,
                    show_reactivate_button: false,
                });
            } else if (user_status === 'active' || user_is_active) {
                this.setState({
                    show_activate_plan_btn: false,
                    show_demo_button: true,
                    show_reactivate_button: false,
                });
            } else if (window.location.pathname !== '/customers/change_plan/') {
                this.setState({
                    show_activate_plan_btn: false,
                    show_demo_button: false,
                    show_reactivate_button: true,
                });
            }

            window.user_status = user_status;

            const discover_analytics = data.discover_analytics || false;
            const gsc_data = data.search_analytics || false;

            this.setState({
                show_discover_analytics: discover_analytics,
                show_gsc_data: gsc_data,
                show_ai_tracking: data.ai_tracking || false,
                show_commerce: data.commerce_analytics || false,
                user_permissions: data ?? {},
            });
            document.dispatchEvent(this.getUserStatus);
        } catch (err) {
            console.log(err);
        }
    }

    handleMoodeChange() {
        const isDark = JSON.parse(localStorage.getItem('dark-mode'));
        this.setState({ isDark });
    }

    toggleResponsiveTopMenu() {
        this.setState({
            openResponsiveTopMenu: !this.state.openResponsiveTopMenu,
        });
    }

    toggleMode() {
        const isContain = this.body.classList.contains('dark-mode');

        if (isContain) {
            this.body.classList.remove('dark-mode');
            localStorage.setItem('dark-mode', false);
            document.dispatchEvent(this.changeMoodEvent);
            this.setState({
                modeIconClassName: 'icon-moon',
            });
        } else {
            this.body.classList.add('dark-mode');
            localStorage.setItem('dark-mode', true);
            document.dispatchEvent(this.changeMoodEvent);
            this.setState({
                modeIconClassName: 'icon-sun',
            });
        }
    }

    toggleDomainVisibility() {
        const isContain = this.body.classList.contains('hide-domain');

        if (isContain) {
            this.body.classList.remove('hide-domain');
            localStorage.setItem('hide-domain', false);
            document.dispatchEvent(this.changeDomainVisibilityEvent);
            this.setState({
                control_domain_btn_name: 'Hide domain',
            });
        } else {
            this.body.classList.add('hide-domain');
            localStorage.setItem('hide-domain', true);
            document.dispatchEvent(this.changeDomainVisibilityEvent);
            this.setState({
                control_domain_btn_name: 'Show Domain',
            });
        }
    }

    toggleFullScreen() {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
        } else if (document.exitFullscreen) {
            document.exitFullscreen();
        }
    }

    updateStyle(value) {
        const sidebarContainer = document.querySelector('.sidebar-container');
        if (sidebarContainer.classList.contains(value)) {
            setView({ view: 'standard' });
            return sidebarContainer.classList.remove(value);
        }
        this.classTypes.forEach((item) => {
            sidebarContainer.classList.remove(item);
        });
        sidebarContainer.classList.add(value);
        setView({ view: value });
    }

    changeLanguage() {
        const key = 'de';
        changeLanguage(key);
    }

    async onLogout() {
        try {
            await logout();
            window.location.href = '/account/login';
        } catch (err) {
            console.log(err);
        }
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <div
                    className={`sidebar ${
                        this.state.openResponsiveTopMenu ? 'sidebar-from-top-menu' : ''
                    }`}
                    id="nav-bar"
                >
                    <ul className={`list-group`}>
                        <li
                            className="centered d-flex align-items-center justify-content-between border-bottom top-part"
                            style={{ textAlign: 'center' }}
                        >
                            <a href="/" className="logo">
                                <img
                                    className="logo-sidebar logo-symbol"
                                    loading="lazy"
                                    alt="logo"
                                    src={
                                        this.state.isDark
                                            ? '/static/img/gddash_logo_dark.png'
                                            : '/static/img/gddash_logo1.png'
                                    }
                                />
                                <img
                                    className="logo-sidebar-mini logo-symbol"
                                    loading="lazy"
                                    alt="logo"
                                    src="/static/img/logo-symbol.svg"
                                />
                            </a>
                            <button
                                className="navbar-toggler"
                                id="toggleId"
                                onClick={this.toggleResponsiveTopMenu}
                            >
                                <div id="header-toggle">
                                    <i className="icon-angle-double-left"></i>
                                </div>
                            </button>
                        </li>
                        <Sidebar
                            default_domain_id={this.state.default_domain_id}
                            domain_id={this.props.domain_id}
                            updateStyle={this.updateStyle}
                            show_discover_analytics={this.state.show_discover_analytics}
                            show_gsc_data={this.state.show_gsc_data}
                            show_ai_tracking={this.state.show_ai_tracking}
                            show_commerce={this.state.show_commerce}
                        />
                    </ul>
                </div>
                {this.state.showTopBanner && (
                    <div className="header-banner">
                        <span className="header-banner-text">
                            {t('layout.header.ai_tracking_banner_message')}
                        </span>
                        <a href="/customers/legacy-ai-upgrade/" className="header-banner-cta">
                            {t('layout.header.ai_tracking_banner_bta')}
                        </a>
                    </div>
                )}
                <header
                    className={`header-primary border-bottom ${
                        this.state.showTopBanner ? 'with-top-banner' : ''
                    }`}
                >
                    <div className="content-left">
                        <a href="/" className="logo ">
                            <img
                                className="logo-symbol logo-menu"
                                loading="lazy"
                                alt="logo"
                                src={
                                    this.state.isDark
                                        ? '/static/img/gddash_logo_dark.png'
                                        : '/static/img/gddash_logo1.png'
                                }
                            />
                            <img
                                className="logo-menu-mini logo-symbol"
                                loading="lazy"
                                alt="logo"
                                src="/static/img/logo-symbol.svg"
                            />
                        </a>
                        {this.props.domains_for_dropdown && !this.state.dont_show_domain && (
                            <SearchDropdown
                                domains={this.props.domains_for_dropdown}
                                domain="{{domain}}"
                                is_superuser={this.props.is_superuser}
                                domain_id={this.props.domain_id}
                                domain_name={this.props.domain_name}
                            />
                        )}
                    </div>
                    <div className="content-right">
                        <ul className="list-group list-group-horizontal nav-items d-flex align-items-center">
                            {this.state.need_onboard && (
                                <li className="list-group">
                                    <a
                                        href="/customers/onboarding/"
                                        className="button button-filled button-primary red width-sm btn d-flex align-items-center justify-content-center"
                                        style={{ background: '#bb1f44' }}
                                    >
                                        Complete your setup
                                    </a>
                                </li>
                            )}
                            {this.state.show_demo_button && (
                                <li className="list-group schedule-a-training-btn">
                                    <a
                                        className="button button-outline button-primary width-sm btn d-flex align-items-center justify-content-center schedule-training-btn"
                                        target="_blank"
                                        rel="noreferrer"
                                        title={t('layout.header.schedule_training')}
                                        href="https://calendly.com/newzdash/gddash-training"
                                    >
                                        <i className="icon-calendar1" />
                                        <span>{t('layout.header.schedule_training')}</span>
                                    </a>
                                </li>
                            )}
                            {this.state.show_reactivate_button && (
                                <li className="list-group">
                                    <a
                                        className="button button-filled button-primary width-sm btn d-flex align-items-center justify-content-center"
                                        target="_blank"
                                        rel="noreferrer"
                                        href={getUpgradeUrl(
                                            '/customers/change_plan/?reactivation=true',
                                        )}
                                    >
                                        <span>{t('layout.header.reactivate')}</span>
                                    </a>
                                </li>
                            )}
                            {this.state.show_activate_plan_btn && (
                                <li className="list-group activate-plane-component">
                                    <ActivatePlanComponent />
                                </li>
                            )}
                            <NotificationsBell />
                            <li className="list-group">
                                <button className="btn-icon" onClick={this.toggleFullScreen}>
                                    <i className="icon-fullscreen nav-icon"></i>
                                </button>
                            </li>
                            <li className="list-group">
                                <a className="btn-icon" href="/support">
                                    <i className="icon-help-circle_1 nav-icon"></i>
                                </a>
                            </li>
                            <li className="list-group">
                                <button className="btn-icon" onClick={this.toggleMode}>
                                    <i
                                        id="mode-icon"
                                        className={`${this.state.modeIconClassName} nav-icon`}
                                    ></i>
                                </button>
                            </li>
                            {/* {this.props.domain_name && (
                                    <li className="list-group">
                                        <div className="circle-with-content">
                                            <DomainImage domain_name={this.props.domain_name} />
                                        </div>
                                    </li>
                                )} */}
                            <li className="list-group">
                                <ul className="list-group settings">
                                    <li className="d-flex justify-content-between align-items-center">
                                        <div className="dropdown ">
                                            <a
                                                className="list-group-item-action"
                                                href="#"
                                                role="button"
                                                id="dropdownMenuLink"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >
                                                <i className="icon-settings1 nav-icon"></i>
                                            </a>
                                            <ul
                                                className="dropdown-menu settings-menu"
                                                aria-labelledby="dropdownMenuLink"
                                            >
                                                {this.state.is_superuser && (
                                                    <>
                                                        <li>
                                                            <a
                                                                className="dropdown-item"
                                                                href="/customers/list/?customer_type=active_customers"
                                                            >
                                                                <UsersRound />
                                                                {t('layout.menu.customers')}
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a
                                                                className="dropdown-item"
                                                                href="/domains/gsc-test-data/"
                                                            >
                                                                <i className="icon-Icon-Stroke"></i>
                                                                {t('layout.menu.gsc_test')}
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a
                                                                className="dropdown-item"
                                                                href="/domains/scrap-pages-test/"
                                                            >
                                                                <i className="icon-Icon-Stroke-1"></i>
                                                                {t('layout.menu.test_page_scraper')}
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a
                                                                className="dropdown-item"
                                                                href="/domains/get-domain-per-user/"
                                                            >
                                                                <i className="icon-Icon-Stroke-2"></i>
                                                                {t('layout.menu.domain_runs_qa')}
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a
                                                                className="dropdown-item"
                                                                href="/domains/without-data/"
                                                            >
                                                                <i className="icon-n_author-performance-1"></i>
                                                                {t(
                                                                    'layout.menu.domains_missing_entities',
                                                                )}
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a
                                                                className="dropdown-item"
                                                                href="/customers/bulk-plan-change/"
                                                            >
                                                                <FileText />
                                                                {t('layout.menu.bulk_plan_change')}
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a
                                                                className="dropdown-item"
                                                                href="/customers/user-activities/"
                                                            >
                                                                <i className="icon-n_author-performance-1"></i>
                                                                {t('layout.menu.user_activities')}
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a
                                                                className="dropdown-item"
                                                                href="/halubcnd"
                                                            >
                                                                <i className="icon-Group-1000001833"></i>
                                                                {t('layout.menu.admin')}
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <button
                                                                className="dropdown-item"
                                                                id="domain-control-btn"
                                                                onClick={
                                                                    this.toggleDomainVisibility
                                                                }
                                                            >
                                                                <i
                                                                    className="icon-Vector-4"
                                                                    style={{ fontSize: '15px' }}
                                                                ></i>
                                                                {
                                                                    this.state
                                                                        .control_domain_btn_name /* likely dynamic, skip t() */
                                                                }
                                                            </button>
                                                        </li>
                                                    </>
                                                )}

                                                <li>
                                                    <a
                                                        className="dropdown-item"
                                                        href="/customers/change_customer_profile"
                                                    >
                                                        <i
                                                            className="icon-Vector-Stroke-5"
                                                            style={{ fontSize: '23px' }}
                                                        ></i>
                                                        {t('layout.menu.my_profile')}
                                                    </a>
                                                </li>

                                                <li>
                                                    <a className="dropdown-item" href="/settings">
                                                        <i className="icon-Icon-Stroke"></i>
                                                        {t('layout.menu.settings')}
                                                    </a>
                                                </li>

                                                {!this.state.is_superuser &&
                                                    this.state.isNotViewer && (
                                                        <>
                                                            <li>
                                                                <a
                                                                    className="dropdown-item"
                                                                    href="/customers/payment-methods"
                                                                >
                                                                    <BadgeDollarSign />
                                                                    {t(
                                                                        'layout.menu.payment_methods',
                                                                    )}
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a
                                                                    className="dropdown-item"
                                                                    href={getUpgradeUrl(
                                                                        '/customers/change_plan/',
                                                                    )}
                                                                >
                                                                    <Wallet />
                                                                    {t('layout.menu.change_plan')}
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a
                                                                    className="dropdown-item"
                                                                    href="/customers/licenses/"
                                                                >
                                                                    <Landmark />
                                                                    {t(
                                                                        'layout.menu.billing_history',
                                                                    )}
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a
                                                                    className="dropdown-item"
                                                                    href="/commerce/settings/"
                                                                >
                                                                    <i className="icon-Icon-Stroke"></i>
                                                                    {t(
                                                                        'layout.menu.commerce_settings',
                                                                    )}
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a
                                                                    className="dropdown-item"
                                                                    href="/domains/get-user-domains/"
                                                                >
                                                                    <UserSearch />
                                                                    {t(
                                                                        'layout.menu.gsc_search_data_import',
                                                                    )}
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a
                                                                    className="dropdown-item"
                                                                    href="/tools/add-ons/"
                                                                >
                                                                    <WalletCards />
                                                                    {t('layout.menu.add_ons')}
                                                                </a>
                                                            </li>
                                                        </>
                                                    )}
                                                <li>
                                                    <button
                                                        onClick={this.onLogout}
                                                        className="dropdown-item"
                                                    >
                                                        <i className="icon-Vector-Stroke-6"></i>
                                                        {t('layout.menu.sign_out')}
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                            <li className="list-group">
                                <Language />
                            </li>
                        </ul>
                    </div>
                </header>
                <TopMenu
                    default_domain_id={this.state.default_domain_id}
                    domain_id={this.props.domain_id}
                    updateStyle={this.updateStyle}
                    toggleResponsiveTopMenu={this.toggleResponsiveTopMenu}
                    show_discover_analytics={this.state.show_discover_analytics}
                    show_gsc_data={this.state.show_gsc_data}
                    show_ai_tracking={this.state.show_ai_tracking}
                    show_commerce={this.state.show_commerce}
                    showTopBanner={this.state.showTopBanner}
                />
                <StripeMessage />
                <ShowMessage />
            </>
        );
    }
}

export default withTranslation()(Layout);
